export default {
  name: 'admin',
  users: 'users',
  userDisplay: 'userDisplay',
  roles: 'roles',
  editUser: 'editUser'
};
